import { createFileRoute, redirect } from '@tanstack/react-router';

import { DefaultError } from 'components/DefaultError';

import { localStorage } from 'helpers/localStorage';

import { getChapterContentOptions } from 'hooks/data/useChapterContent';
import { getChapterInfoOptions } from 'hooks/data/useChapterInfo';
import { preloadProgressData } from 'hooks/useQuery/useQueryProgressData';

import { TrainingContentView } from 'views/TrainingContentView';

export const Route = createFileRoute('/_auth/_buttonView/_layout/training/_app/$id/_content/$chapter/$page')({
  component: TrainingContentView,
  staticData: {
    disableBackButton: true,
    disableButtonBar: true,
    disableBreadcrumbs: true,
    disableLayout: true,
    disablePointBar: true,
  },
  beforeLoad: async ({ context, params }) => {
    const data = await preloadProgressData(context.queryClient, [params.id]);

    if (data.length === 0 && process.env.NODE_ENV !== 'development') {
      throw redirect({ to: '/training/$id/', params: { id: params.id } });
    }
  },
  loader: async ({ context, params }) => {
    context.disableSupportButton = true;

    const { queryClient } = context;

    const user = localStorage.get('USER');

    if (user === undefined) {
      return {
        chapterData: null,
        chapterContent: null,
        progress: null,
      };
    }

    const [chapterData, chapterContent] = await Promise.all([
      queryClient.ensureQueryData(getChapterInfoOptions(params)),
      queryClient.ensureQueryData(getChapterContentOptions({ id: params.id, chapterId: params?.chapter })),
    ]);

    const chapter = chapterData?.find(({ id }) => {
      return id === params.chapter;
    });

    context.title = chapter?.title ?? null;

    return {
      chapterData,
      chapterContent,
    };
  },

  errorComponent: DefaultError,
});
